<template>
<!-- プロジェクト詳細画面 -->
<CCard>
  <CCardHeader>
    <h2>プロジェクト詳細</h2>
  </CCardHeader>
  <CCardBody>
    <CRow v-if="errorMessage">
      <CCol><p class="text-danger">{{ errorMessage }}</p></CCol>
    </CRow>
    <CRow>
      <CCol sm="6">
        <table class="table" v-if="items">
          <tr>
            <th>顧客会社名</th>
            <td>{{ items.company_name }}</td>
          </tr>
          <tr>
            <th>プロジェクト名</th>
            <td>{{ items.name }}</td>
          </tr>
          <tr>
            <th>自社管理者</th>
            <td>{{ items.private_staff_name }}</td>
          </tr>
          <tr>
            <th>顧客会社担当者</th>
            <td>{{ items.staff_name }}</td>
          </tr>
          <tr>
            <th>関連会社</th>
            <td>{{ items.related }}</td>
          </tr>
          <tr>
            <th>その他関連</th>
            <td>{{ items.other_related }}</td>
          </tr>
          <tr>
            <th>始業時刻</th>
            <td>{{ items.start_time }}</td>
          </tr>
          <tr>
            <th>終了時刻</th>
            <td>{{ items.end_time }}</td>
          </tr>
          <tr>
            <th>休憩開始時間</th>
            <td>{{ items.break_start_time }}</td>
          </tr>
          <tr>
            <th>休憩終了時間</th>
            <td>{{ items.break_end_time }}</td>
          </tr>
          <tr>
            <th>基準時間(表示用)</th>
            <td>{{ items.base_time }}</td>
          </tr>
          <tr>
            <th>基準時間(下限)</th>
            <td>{{ items.base_time_min }}</td>
          </tr>
          <tr>
            <th>基準時間(上限)</th>
            <td>{{ items.base_time_max }}</td>
          </tr>
          <tr>
            <th>契約形態</th>
            <td>{{ items.contract }}</td>
          </tr>
          <tr>
            <th>その他契約事項</th>
            <td>{{ items.other_contract }}</td>
          </tr>
          <tr>
            <th>開発言語</th>
            <td>{{ items.language }}</td>
          </tr>
          <tr>
            <th>その他必要技術</th>
            <td>{{ items.other_tech }}</td>
          </tr>
        </table>
      </CCol>
    </CRow>
    <CRow class="mt-3 align-items-center">
      <CCol class="text-start">
        <router-link :to="{ name: projectList }">
          <button class="btn btn-secondary">戻る</button>
        </router-link>
      </CCol>
      <CCol class="text-center">
        <router-link :to="{ name: projectUpdate, params: { value: items } }">
          <button class="btn btn-info">編集</button>
        </router-link>
      </CCol>
      <!-- 空白スペース用 -->
    <CCol ></CCol>
    </CRow>
  </CCardBody>
</CCard>
</template>


<script>
import ConstList from './../ConstList'
import axios from 'axios'
export default {
  name: 'ProjectInfo',
  data() {
    return {
      authority: [],
      items: '',
      projectList: '',
      projectInfo: '',
      projectUpdate: '',
      errorMessage: '',
    }
  },

  created() {
        this.projectList = ConstList.ROUTE_PROJECT_LIST;
        this.projectInfo = ConstList.ROUTE_PROJECT_INFO;
        this.projectUpdate = ConstList.ROUTE_PROJECT_UPDATE;
      },

  // 一覧から選択したプロジェクトの情報取得
  mounted: function () {
    if (this.$route.params.value) {
      this.items = this.$route.params.value
      return
    }

    const id = Number(this.$route.params.id)
    if (!Number.isInteger(id) || id <= 0) {
      this.errorMessage = 'プロジェクトを特定できません。'
      return
    }

    axios
      .get(process.env.VUE_APP_API_ORIGIN + `/management/projects/${id}`)
      .then(response => {
        this.items = response.data || ''
        if (!this.items) this.errorMessage = 'プロジェクトが見つかりません。'
      })
      .catch(error => {
        this.errorMessage = 'プロジェクト情報を取得できませんでした。'
        console.error('プロジェクト詳細取得失敗:', error)
      })
  }
}
</script>

<style scoped>
td {
  word-break: break-all;
}
</style>
